import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=c0cfc81a&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0cfc81a')) {
      api.createRecord('c0cfc81a', component.options)
    } else {
      api.reload('c0cfc81a', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=c0cfc81a&", function () {
      api.rerender('c0cfc81a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z1QdSMuQWfG7/JS/videoIframe.vue"
export default component.exports